import { useEffect, useState } from "react"
import {
  CompositeSourceDot,
  fetchCompositeSourceDots,
} from "utils/compositeSourceDots"

const useCompositeSourceDots = (mintTransactionHash?: string | null, enabled = true) => {
  const [data, setData] = useState<CompositeSourceDot[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  useEffect(() => {
    if (!enabled || !mintTransactionHash) {
      setData([])
      setLoading(false)
      setError(false)
      return
    }

    let cancelled = false
    setLoading(true)
    setError(false)

    fetchCompositeSourceDots(mintTransactionHash)
      .then((sourceDots) => {
        if (!cancelled) setData(sourceDots)
      })
      .catch(() => {
        if (!cancelled) setError(true)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [enabled, mintTransactionHash])

  return { data, loading, error }
}

export default useCompositeSourceDots
